import { Injectable } from '@angular/core';

import { QueryEntity } from '@datorama/akita';

import { PricePlansStore } from './price-plans.store';
import { PricePlansState } from './price-plans.state';

@Injectable({ providedIn: 'root' })
export class PricePlansQuery extends QueryEntity<PricePlansState> {
  constructor(protected readonly store: PricePlansStore) {
    super(store);
  }
}
